export const environment = {
  baseUrl: '/api/v1',

  // baseUrl: 'http://192.168.1.19:8080/api/v1',
};
